App.ClientAddress = DS.Model.extend
  address: DS.attr 'string'
  apartment: DS.attr 'string'
  staircase: DS.attr 'string'
  floor: DS.attr 'string'
  doorphone: DS.attr 'string'
  address_comment: DS.attr 'string'
